import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';

import {AttributePermission} from '../types';

/**
 * `deleteAttributePermission` request params
 * (what is used to send to server)
 */
export type DeleteAttributePermissionRequestOptions = Pick<
	AttributePermission,
	'groupId' | 'templateId'
>;

/**
 * `deleteAttributePermission` request
 * (what gets sent to the server)
 */
export type DeleteAttributePermissionRequest = [
	DeleteAttributePermissionRequestOptions['templateId'],
	DeleteAttributePermissionRequestOptions['groupId'],
];

/**
 * `deleteAttributePermission` response
 * (what comes back from the server)
 */
export type DeleteAttributePermissionResponse =
	SuccessResponse<DeleteAttributePermissionResult>;

/**
 * `deleteAttributePermission` result
 * (what is utilized from the server response)
 */
export type DeleteAttributePermissionResult = boolean;

export const deleteAttributePermissionEndpoint = 'deleteAttributePermission';

/**
 * Delete attribute permission
 */
export const deleteAttributePermission = async ({
	groupId,
	templateId,
}: DeleteAttributePermissionRequestOptions) => {
	const client = NetxQueryClient();

	const requestParams: DeleteAttributePermissionRequest = [templateId, groupId];

	return client
		.post<DeleteAttributePermissionResponse>(
			deleteAttributePermissionEndpoint,
			requestParams,
		)
		.then((response) => response.data.result);
};

export default deleteAttributePermission;
